import React from "react" 
import { useParams } from "react-router-dom"
import _ from "lodash"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, randoms } from "lib/utils"
import { statementBoilerplate } from "./statementBoilerplate"

/* ===== this is the new, preferred statement hook ===== */ 


export default function useStatements(){

  const { tmplid } = useParams()
  const { store, AppStore }:any = appStore()
  const { update }:any = AppStore

  const setStatements = (data:any[]) => update("collections.statement", data)

  const filterStatements = (template:any) => {
    const elementStatements = template.Elements.find( (elem:any) => elem.refstr === store.element.refstr).config.statements
    const filteredStatements = elementStatements.filter( (st:any) => 
      st.parent.includes(store.statementLoadParams.parent)
      && st.level === store.statementLoadParams.level
      && st.parentResult === store.statementLoadParams.parentResult 
    )
    return filteredStatements
  }

  // saves the statement to the template and returns the updated template
  const saveStatement = (template:any, statementObj?:any) => {
    const statementToSave = statementObj || store.actives.statement
    if( !statementToSave ) return
    const clone = _.cloneDeep(template)
    const newTmpl = clone.Elements.map((elem:any) => {
      if( elem.refstr !== store.element.refstr ) return elem
      return {
        ...elem,
        config: {
          ...elem.config,
          statements: elem.config.statements.map( (st:any) => {
            if( st.refstr !== statementToSave.refstr ) return st
            return statementToSave
          })
        }
      }
    })
    return { ...clone, Elements: newTmpl }
  }

  // creates a new statement or adds one from the statements collection
  const insertStatement = ({ template, statement, callbackFn }:{template:any, statement?:any, callbackFn?:any}) => {
    const statementToAdd = (statement) ? statement : {...statementBoilerplate}
    const newStatement = {
      ...statementToAdd,
      refstr: statementToAdd.refstr || randoms.string(12, "a#"),
      parent: "[root]",
      level: 1,
      parentResult: "any" 
    }
    if( callbackFn ){
      callbackFn(newStatement)
    } else {
      return newStatement
    }
  }


  /** === clones the supplied statement === */
  const cloneStatement = (statement:any, callbackFn?:any) => {
    const clone = _.cloneDeep(statement)
    const refstr = randoms.string(12, "a#")
    const cloned = {...clone, refstr}
    if( callbackFn ){
      callbackFn(cloned)
    } else {
      return cloned
    }
  }

  
  // recursive object search
  const findStatement = (obj:any, refstr:string) => {
    let found
    if( obj.refstr === refstr ){
      found = obj
    } else {
      if( obj.nested ){
        Object.values(obj.nested).forEach( (item:any) => {
          if( item.refstr === refstr ){
            found = item
          } else {
            if( item.nested ){
              findStatement(item, refstr)
            }
          }
        })
      }
    }
    return found
  }

  const searchForStatement = (refstr:string) => {
    const statements = store.element.config.statements
    let result
    statements.forEach( (item:any) => {
      // this starts a recursive search for the statement
      result = findStatement(item, refstr)
    })
    console.log(result)
    return result
  }






  const statementTools = {
    clone: cloneStatement,
    insert: insertStatement,
    save: saveStatement,
    filter: filterStatements,
    set: setStatements,
    search: searchForStatement,
  }

  return {
    statementTools
  }
}